function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7167 18.5417H7.28332C3.19165 18.5417 1.44165 16.7917 1.44165 12.7001V12.5917C1.44165 8.89173 2.89998 7.1084 6.16665 6.80006C6.49998 6.77506 6.81665 7.02506 6.84998 7.36673C6.88332 7.7084 6.63332 8.01673 6.28332 8.05006C3.66665 8.29173 2.69165 9.52506 2.69165 12.6001V12.7084C2.69165 16.1001 3.89165 17.3001 7.28332 17.3001H12.7167C16.1083 17.3001 17.3083 16.1001 17.3083 12.7084V12.6001C17.3083 9.5084 16.3166 8.27506 13.65 8.05006C13.3083 8.01673 13.05 7.71673 13.0833 7.37506C13.1166 7.0334 13.4083 6.77506 13.7583 6.8084C17.075 7.09173 18.5583 8.8834 18.5583 12.6084V12.7167C18.5583 16.7917 16.8083 18.5417 12.7167 18.5417Z",
  fill: "#0851B5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 13.0251C9.65833 13.0251 9.375 12.7417 9.375 12.4001V1.66675C9.375 1.32508 9.65833 1.04175 10 1.04175C10.3417 1.04175 10.625 1.32508 10.625 1.66675V12.4001C10.625 12.7501 10.3417 13.0251 10 13.0251Z",
  fill: "#0851B5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10 13.9583C9.8417 13.9583 9.68337 13.9 9.55837 13.775L6.7667 10.9833C6.52503 10.7416 6.52503 10.3416 6.7667 10.1C7.00837 9.85828 7.40837 9.85828 7.65003 10.1L10 12.45L12.35 10.1C12.5917 9.85828 12.9917 9.85828 13.2334 10.1C13.475 10.3416 13.475 10.7416 13.2334 10.9833L10.4417 13.775C10.3167 13.9 10.1584 13.9583 10 13.9583Z",
  fill: "#0851B5"
});

var SvgImport = function SvgImport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/import.00ed7d75.svg";
export { ForwardRef as ReactComponent };